import React from "react";
import { TextField } from "@mui/material";

export default function DateField({ question, value, onChange }: any) {
  const [type, setType] = React.useState("text");

  return (
    <TextField
      type={type}
      fullWidth
      size="small"
      value={value || ""}
      placeholder="dd-mm-yyyy"
      onFocus={() => setType("date")}
      onBlur={(e) => {
        if (!e.target.value) setType("text");
      }}
      onChange={(e) => onChange && onChange(e.target.value)}
      sx={{ marginTop: 1 }}
      inputProps={{ maxLength: 10 }}
    />
  );
}
